var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.initialized)?_c('div',[_c('wms-global-meta'),_c('wms-router')],1):_c('div',{staticClass:"spinner spinner--fixed"})}
var staticRenderFns = []

export { render, staticRenderFns }